import { requestResourceByName, Resource, useScopedSelector } from 'ia-react-core';
import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import getNotificationsApiRoot from '../../../../utils/getNotificationsApiRoot';
import Section from './Section';
import { NotificationsState } from '../../../../interfaces/NotificationsState';
import getSections from './getSections';
import { StyledWrapper } from './Sections.styles';
import { NotificationsCountResourceInfo } from '../../../NotificationsCountResource/NotificationsCountResource';
import NotificationsResourceGroupLoader from './NotificationsResourceGroupLoader';

export interface SectionsProps { }
export const NotificationActionRequiredDataTestId = 'notificationActionRequiredDataTestId';
export const NotificationUnseenDataTestId = 'notificationUnseenDataTestId';
export const NotificationSeenDataTestId = 'notificationSeenDataTestId';

const Sections: FC<SectionsProps> = () => {
  const notifications: NotificationsState = useScopedSelector('/App.features.notifications');
  const { t } = useTranslation('Notifications');
  const ids = (notifications?.notifications?.length ?? 0) > 0 ? notifications.notifications.map((n) => n.id) : [];
  const dispatch = useDispatch();
  const sections = useMemo(() => (getSections(notifications)), [notifications]);
  const onComplete = useCallback(() => {
    dispatch(requestResourceByName(NotificationsCountResourceInfo.name));
  }, [dispatch]);

  return (
    <NotificationsResourceGroupLoader>
      {ids.length > 0 &&
        <Resource
          name="/App.features.notifications.notificationsMarkAsSeen"
          method="post"
          url={`${getNotificationsApiRoot()}/seen?Audience=client`}
          data={{ ids }}
          autoRequest
          onComplete={onComplete}
        />}
      <StyledWrapper>
        <Section title={t('actionRequired')} notifications={sections.actionRequired} data-testid={NotificationActionRequiredDataTestId} />
        <Section title={t('unseen')} notifications={sections.unseen} data-testid={NotificationUnseenDataTestId} />
        <Section title={t('seen')} notifications={sections.seen} data-testid={NotificationSeenDataTestId} />
      </StyledWrapper>
    </NotificationsResourceGroupLoader>
  );
};
export default Sections;
